// src/hooks/useAuthRole.js
import { useEffect, useState } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { ref, onValue } from "firebase/database";
import { auth, db } from "../firebase";

/**
 * useAuthRole
 * - returns { user, role, loading }
 * - role is the string stored at /admins/{uid}.role or null
 */
export default function useAuthRole() {
  const [user, setUser] = useState(null);
  const [role, setRole] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let roleUnsub = null;
    const unsub = onAuthStateChanged(auth, (u) => {
      setUser(u || null);
      setRole(null);

      if (!u) {
        setLoading(false);
        if (roleUnsub) {
          roleUnsub();
          roleUnsub = null;
        }
        return;
      }

      // Begin loading role
      setLoading(true);
      const r = ref(db, `/admins/${u.uid}`); // <-- read /admins not /roles
      roleUnsub = onValue(
        r,
        (snap) => {
          const val = snap.val() || {};
          setRole(val.role || null);
          setLoading(false);
        },
        (err) => {
          console.warn("Failed to read admin role:", err);
          setRole(null);
          setLoading(false);
        }
      );
    });

    return () => {
      unsub();
      if (roleUnsub) roleUnsub();
    };
  }, []);

  return { user, role, loading };
}
